// frontend/src/utils/avatarUtils.js

export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return null;
  
  const baseUrl =
    process.env.REACT_APP_AVATAR_URL?.replace(/\/+$/, "") ||
    "http://localhost:8000/storage";
  
  const cleanPath = avatarPath.replace(/^\/+/, "");
  
  return `${baseUrl}/${cleanPath}`;
};